// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qKbiPV6XqkGGcDBHMSaH {
  position: relative;
  flex-shrink: 0;
}

/* Hangs from its trigger. The panel and rows themselves are darkMenu's. */
.jZZklOdrk3xhIRVLlE2v {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 210px;
  z-index: 100;
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/top/HeaderMenu.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".wrapper {\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* Hangs from its trigger. The panel and rows themselves are darkMenu's. */\n.panel {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  min-width: 210px;\n  z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `qKbiPV6XqkGGcDBHMSaH`,
	"panel": `jZZklOdrk3xhIRVLlE2v`
};
export default ___CSS_LOADER_EXPORT___;
